<template>
  <div>
    <router-view></router-view>
    <!-- <FloatingButton @click="handleButtonClick()" /> -->
  </div>
</template>

<script>
// import FloatingButton from './components/FloatingButton.vue';

export default {
  name: 'App',
  // components: {
  //   FloatingButton
  // },
  data() {
    return {

    }
  },
  methods: {
    // handleButtonClick(e) {
    //   console.log(e)
    //   console.log('悬浮按钮被点击')
    //   // 在这里添加点击处理逻辑
    //   const a = document.createElement('a');
    //   a.href = encodeURI("https://t.me/longaotianData");

    //    a.target = '_blank';
    //     a.rel = 'noopener noreferrer'; // 安全优化

    //   // 兼容现代浏览器和IE的点击触发
    //   if (document.createEvent) {
    //     const event = document.createEvent('MouseEvents');
    //     event.initEvent('click', true, true);
    //     a.dispatchEvent(event);
    //   } else {
    //     a.click();
    //   }
    // }
  }
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
}

.topMenuSelected {
  color: #3E4F7A;
  font-size: 20px;
  font-weight: 800;
  /* border-bottom: 4px solid #2962F1;
  padding-bottom: 4px; */
}

@font-face {
  font-family: 'PingFang';
  src: url('@/assets/fonts/PingFang Medium_downcc.otf') format('opentype');
  font-weight: normal;
  font-style: normal;
}

body {
  font-family: 'MyFont', sans-serif;
}
</style>
